export default function getURL(term, timetable) {
    const courseCodes = Object.keys(timetable);
    const timetableStr = courseCodes
        .map((courseCode) => {
            const sections = timetable[courseCode];
            const sectionStr = sections.join(',');
            return `${courseCode}:_${sectionStr}!`;
        })
        .join('');
    return `?semester=${encodeURIComponent(term)}&timetable=${encodeURIComponent(timetableStr)}`;
}
